<template>
    <v-card :class="cardClass">
        <v-card-title class="d-flex align-center">
            <span class="text-h6">{{ title }}</span>
            <v-spacer></v-spacer>

            <template v-if="showStatusPicker">
                <v-combobox :model-value="selectedStatuses"
                            @update:model-value="handleStatusChange"
                            :items="statusOptions"
                            item-title="title"
                            item-value="value"
                            :label="t('selectStatuses')"
                            variant="outlined"
                            density="compact"
                            hide-details
                            multiple
                            class="mx-2">
                    <template v-slot:selection="{ item }">
                        <v-chip :color="item.raw.color"
                                :text="item.raw.title"
                                size="small"
                                variant="flat"
                                label
                                closable
                                @click:close="removeStatus(item.raw)"></v-chip>
                    </template>

                    <template v-slot:item="{ props: itemProps, item }">
                        <v-list-item v-bind="itemProps"
                                     class="d-flex">
                            <template v-slot:title>
                                <v-chip :color="item.raw.color"
                                        :text="item.raw.title"
                                        size="small"
                                        variant="flat"
                                        label></v-chip>
                            </template>
                        </v-list-item>
                    </template>
                </v-combobox>

                <v-divider vertical class="mx-2" style="height: 24px;"></v-divider>
            </template>

            <v-btn icon flat size="small" class="mx-1" @click="expandAll" :title="t('expandAll')">
                <v-icon>mdi-unfold-more-horizontal</v-icon>
            </v-btn>

            <v-btn icon flat size="small" class="mx-1" @click="collapseAll" :title="t('collapseAll')">
                <v-icon>mdi-unfold-less-horizontal</v-icon>
            </v-btn>

            <v-divider vertical class="mx-2" style="height: 24px;"></v-divider>

            <v-btn icon flat size="small" class="mx-1" @click="zoomIn">
                <v-icon>mdi-magnify-plus</v-icon>
            </v-btn>

            <v-btn icon flat size="small" class="mx-1" @click="zoomOut">
                <v-icon>mdi-magnify-minus</v-icon>
            </v-btn>

            <v-btn icon flat size="small" class="mx-1" @click="zoomToFit" :title="t('zoomToFit')">
                <v-icon>mdi-fit-to-page</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
            <!-- Bryntum renders into this element (`appendTo`); max-width + overflow-x give the
                 horizontal scrollbar -->
            <div ref="ganttContainer"
                 :class="{ 'rdrive-gantt--tinted': tinted }"
                 :style="containerStyle">
                <v-overlay v-if="isInitialLoad" :model-value="true" contained class="d-flex align-center justify-center">
                    <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
                    <div class="ml-4">{{ t('loading') }}...</div>
                </v-overlay>
            </div>
        </v-card-text>
    </v-card>
</template>

<script src="./model.js"></script>
<style src="./style.css"></style>
